import { setAuthenticator } from '@ms/yammer-data/dist/authentication';
import { NetworkType } from '@ms/yammer-data/dist/state/types';
import { Authenticator, VivaConnectionsAuthenticator } from '@ms/yammer-web-authenticators';
import { TeamsAuthenticator } from '@ms/yammer-web-authenticators/dist/teams';
import { getNetworkContext } from '@ms/yammer-web-support/dist/location';
import { hasMetaOsHubContext } from '@ms/yammer-web-support/dist/metaOsHub';
import config from 'bootstrap/config';
import { ensureVivaConnectionsInitialized, getAuthToken, isInVivaConnectionsApp } from 'vivaConnections';

import { getAuthTokenCache, initializeAuthTokenCache } from './authTokenCache';

type GetAuthenticator = () => Promise<Authenticator>;
const getAuthenticator: GetAuthenticator = async () => {
  if (await hasMetaOsHubContext()) {
    initializeAuthTokenCache();

    return new TeamsAuthenticator(getAuthTokenCache);
  }

  if (isInVivaConnectionsApp()) {
    ensureVivaConnectionsInitialized();

    return new VivaConnectionsAuthenticator(getAuthToken);
  }

  const networkContext = getNetworkContext(window.location.pathname);
  const tenant = networkContext?.networkType === NetworkType.Canonical ? networkContext.permalink : config.msal.tenant;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (config as any).adal = config.msal;

  const { default: MsalRedirectAuthenticator } = await import(
    /* webpackChunkName: "4-auth-msal" */ '@ms/yammer-web-authenticators/dist/redirect/MsalRedirectAuthenticator'
  );

  return new MsalRedirectAuthenticator({
    ...config.msal,
    tenant,
  });
};

type SetupAuthenticator = () => Promise<Authenticator>;
export const setupAuthenticator: SetupAuthenticator = async () => {
  const authenticator = await getAuthenticator();
  setAuthenticator(authenticator);

  return authenticator;
};
